import { HttpClient } from '@angular/common/http';
import { Injectable, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ActionService } from 'src/app/digigov/services/worklist.service';

import { CommonService } from './common.service';

import { AppGenServiceService } from './app-gen-service.service';
import { MessageDisplayService } from 'src/app/digigov/services/message-display/message-display.service';
import {
  ComponentConfig,
  ComponentLoaderDirective,
} from 'src/app/component-loader.directive';
import { RuleService } from './rule.service';
import { AppGenDialogComponent } from '../app-gen-dialog/app-gen-dialog.component';
import { InputType } from 'dg-input-lib';
import { DgDialogService } from 'src/app/digigov/dg_components/dg-dialog/dg-dialog.service';
import { CreateDraftComponent } from '../../create-draft/create-draft.component';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';
import { AdditionalVO } from '../app-gen-main/app-gen-main.component';
import { DatePipe } from '@angular/common';
import { Subject, BehaviorSubject } from 'rxjs';
import { tap, take, filter } from 'rxjs/operators';
import { Validation } from 'dg-error-lib';
import { DraftDialogComponent } from 'src/app/digigov/dg_components/dg-draft/draft-dialog/draft-dialog.component';

interface InputDataModel {
  inputId: string | number;
  inputType: string | number;
  inputName?: string;
  inputPlaceholder?: string;
  inputMandatory?: boolean;
  inputOptions?: ComboModel[];
  inputValue?: unknown;
  validations?: Validation[];
}

interface ComboModel {
  id?: string | number;
  optionText: string;
  optionValue: string | number;
  optionDesc?: string;
  isRange?: boolean;
  optionDisabled?: boolean;
  optionIcon?: string;
}
@Injectable({
  providedIn: null,
})
export class ExecutionService {
  cases: any;
  checkSubmitResponse: any;
  inputCaseViewdata: any;
  caseVO: any;
  dataForPost: any;
  menuFetchData: any;
  parentEventData: any;
  customCompRef: ComponentLoaderDirective;
  appFormId: any;
  appRefId: any;
  fieldId: any;
  developerFormData;
  parentCommonService: CommonService;
  notifySaveComponentResponse: Subject<any>;
  notifyRefreshRows: Subject<any>;

  typeTwoCombo: any;

  plmapColData = [];
  refId: any;
  resultValueForAttachId: any[] = [];

  constructor(
    private router: Router,
    private appGenServiceService: AppGenServiceService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private ruleService: RuleService,
    private commonService: CommonService,
    private actionService: ActionService,
    private msgDsplyService: MessageDisplayService,
    private dialogService: DgDialogService,
    private http: HttpClient,
    private authService: AuthenticationService,
    public datePipe: DatePipe
  ) {
    this.notifySaveComponentResponse = new Subject();
    this.notifyRefreshRows = new Subject();
  }

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  cmnFormId;

  appGenFormGroup: FormGroup;
  FORMID: any;
  tid: any;
  appId: any;

  devForm = {};
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  initializedParameter() {
    this.tid = this.commonService.tid;
    this.appId = this.commonService.appId;
    this.FORMID = this.commonService.FORMID;
    this.appGenFormGroup = this.commonService.appGenFormGroup;
    this.cmnFormId = this.commonService.cmnFormId;
  }
  //  this.refId = this.commonService.refId;
  requestValue: BehaviorSubject<boolean> = new BehaviorSubject(false);
  eventData: any;
  excutionList: any;
  eventForm: any;
  eventFormId: any;
  eventTid: any;
  counterVar: any = 1;

  async callUserdefindFunction(
    exe,
    form,
    data,
    formId?,
    tid?,
    afterExecution?,
    rowDataTable?,
    transIdColumn?,
    addRowDelete?,
    res?,
    columnData?,
    colAr?,
    roAr?,
    tabFieldId?
  ) {
    const a = await import(
      'src/app/app-gen-client/custom-function/custom-functions.service'
    );
    const dynamicService = new a['CustomFunctionsService'](
      this.appGenFormGroup,
      this.commonService.resultObj,
      this.inputCaseViewdata,
      this.parentEventData,
      this.cases,
      this.caseVO,
      this.dataForPost,
      this.menuFetchData,
      this.http,
      this.dialog,
      this.commonService.dataTableRowData,
      this.authService,
      this.commonService.additionalVOList,
      this.appGenServiceService,
      data,
      this.toastr,
      this.requestValue,
      this.datePipe,
      this.commonService
    );

    let parameters =
      exe.implementingMethod?.match(/\(.*\)/g) != null
        ? exe.implementingMethod?.match(/\(.*\)/g)
        : '()';
    let methodName = exe.implementingMethod?.replace(parameters, '');

    if (exe?.json?.isTypescript) {
      eval('dynamicService.' + methodName + parameters);
      this.requestValue?.subscribe((res) => {
        if (res && this.counterVar == 1) {
          this.requestValue = new BehaviorSubject(false);
          if (this.excutionList == undefined) {
            this.executeEventService(
              afterExecution,
              form,
              data,
              formId,
              tid,
              rowDataTable,
              transIdColumn,
              addRowDelete,
              res,
              columnData,
              colAr,
              roAr,
              tabFieldId
            );
          } else {
            data = this.eventData;
            afterExecution = this.excutionList;
            form = this.eventForm;
            formId = this.eventFormId;
            tid = this.eventTid;

            this.executeEventService(
              afterExecution,
              form,
              data,
              formId,
              tid,
              rowDataTable,
              transIdColumn,
              addRowDelete,
              res,
              columnData,
              colAr,
              roAr,
              tabFieldId
            );
            this.counterVar++;
          }
        } else {
          this.excutionList = afterExecution;
          this.eventForm = form;
          this.eventData = data;
          this.eventFormId = formId;
          this.eventTid = tid;
          this.counterVar = 1;
        }
      });
    } else {
      eval('dynamicService.' + methodName + parameters);
      this.executeEventService(
        afterExecution,
        form,
        data,
        formId,
        tid,
        rowDataTable,
        transIdColumn,
        addRowDelete,
        res,
        columnData,
        colAr,
        roAr,
        tabFieldId
      );
    }
  }
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  executeEventService(
    afterExecution,
    form,
    data,
    formId,
    tid,
    rowDataTable,
    transIdColumn,
    addRowDelete,
    res,
    columnData,
    colAr,
    roAr,
    tabFieldId,
    plMapColumnId?
  ) {
    if (data) {
      this.callForCheckBoxAndMultiSelect(data);
    }
    let beforeExecutionEvent = [];
    let afterExecutionEvent = [];
    let isSubmit = 0;
    afterExecution?.forEach((exe) => {
      console.log('execution type', exe);

      if (
        exe.executionType == 533312 ||
        exe.executionType == 533325 ||
        exe.executionType == 533309 ||
        exe.executionType == 533305 ||
        isSubmit > 0
      )
        isSubmit++;

      if (isSubmit > 1) {
        afterExecutionEvent.push(exe);
      } else {
        beforeExecutionEvent.push(exe);
      }
    });
    if (
      beforeExecutionEvent &&
      Array.isArray(beforeExecutionEvent) &&
      beforeExecutionEvent.length != 0
    ) {
      this.executeBasedOnType(
        this.commonService.appGenFormGroup,
        data,
        formId,
        tid,
        beforeExecutionEvent,
        afterExecutionEvent,
        rowDataTable,
        transIdColumn,
        addRowDelete,
        res,
        columnData,
        colAr,
        roAr,
        tabFieldId,
        plMapColumnId
      );
    }
  }

  callForCheckBoxAndMultiSelect(data) {
    if (data?.fieldType == 19) {
      let defaultVal = this.appGenServiceService.appGenData[data.fieldId];
      let comboMapValues = data.attribute?.comboMapValues;

      comboMapValues?.forEach(function (value, index) {
        comboMapValues[index].selected = defaultVal[index];
      });
    }
    if (data?.fieldType == 81) {
      let defaultVal = this.appGenServiceService.appGenData[data.fieldId];
      data.attribute?.comboMapValues?.forEach(function (value2, index1) {
        delete value2?.selected;
      });

      defaultVal?.forEach(function (value1) {
        data.attribute?.comboMapValues?.forEach(function (value2) {
          if (value1.optionValue == value2.optionValue) {
            value2.selected = true;
          }
        });
      });
    }
  }
  callVisibilityRule(data, form, tid, isAdvanceRule?, tabFieldId?) {
    this.ruleService.GetValueFromData(
      data,
      form,
      tid,
      isAdvanceRule,
      tabFieldId
    );
  }
  callRuleObject(
    rule,
    form,
    mapData,
    tid,
    isAdvanceRule,
    tabFieldId,
    columnData
  ) {
    this.ruleService.callRuleObject(
      rule,
      form,
      mapData,
      tid,
      isAdvanceRule,
      tabFieldId,
      columnData
    );
  }
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  // CallGenerateDraftFun(data, trangactionId, appId) {
  //   this.commonService.callGenerateDraft(data, trangactionId, appId);
  // }

  // //-----------------------------------------------------------------------------------------//
  // //-----------------------------------------------------------------------------------------//
  // //-----------------------------------------------------------------------------------------//

  // GetDraftDataFun(formId, tid, exe, appId) {
  //   this.commonService.getDraftData(formId, tid, exe, appId);
  // }

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  callAdvanceRule(data) {
    data?.cmnFormFieldEventList?.forEach((index) => {
      let cmnFormFieldEventList = index;
      cmnFormFieldEventList?.cmnEventExecutionList?.forEach((exe) => {
        let cmnEventExecutionList = exe;
        //cmnFormFieldEventList.cmnEventExecutionList[exe];
        if (cmnEventExecutionList?.executionType == 533302) {
          this.createAdvanceRule(cmnEventExecutionList, data);
        }
      });
    });
  }
  createAdvanceRule(
    cmnEventExecutionList,
    data,
    formId?,
    tid?,
    afterExecution?,
    rowDataTable?,
    transIdColumn?,
    addRowDelete?,
    resultObjData?,
    columnData?,
    colAr?,
    roAr?,
    tabFieldId?
  ) {
    let entityAttributeJson = this.commonService.getEntityAttributeMapData(
      this.commonService.resultObj,
      this.appGenServiceService.getAppGenData(this.cmnFormId, this.tid),
      false,
      false,
      null, // this.developerFormData,
      false,
      false
    );
    this.executeRule(
      data,
      cmnEventExecutionList.ruleSubNotiId,
      entityAttributeJson,
      this.commonService.appGenFormGroup,
      formId,
      tid,
      afterExecution,
      rowDataTable,
      transIdColumn,
      addRowDelete,
      resultObjData,
      columnData,
      colAr,
      roAr,
      tabFieldId
    );
  }

  redirectTo(uri: string) {
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([uri]));
  }

  executeBasedOnType(
    form?: FormGroup,
    data?: any,
    formId?,
    tid?,
    beforeExecution?,
    afterExecution?,
    rowDataTable?,
    transIdColumn?,
    addRowDelete?,
    res?,
    columnData?,
    colAr?,
    roAr?,
    tabFieldId?,
    plMapColumnId?
  ) {
    this.initializedParameter();
    let flag = false;
    if (!formId) formId = this.cmnFormId;
    if (!tid) tid = this.tid;

    beforeExecution.forEach((exe) => {
      if (!flag) {
        if (exe.executionType == 533306) {
          /*   this.CocallVisibilityRule(data, form); */
          this.callRuleObject(
            exe,
            this.appGenFormGroup,
            data,
            tid,
            null,
            tabFieldId,
            columnData
          );
          //this.callVisibilityRule(data, this.appGenFormGroup, this.tid,null,tabFieldId);
        } else if (exe.executionType == 533302) {
          this.createAdvanceRule(
            exe,
            data,
            formId,
            tid,
            afterExecution,
            rowDataTable,
            transIdColumn,
            addRowDelete,
            res,
            columnData,
            colAr,
            roAr,
            tabFieldId
          );
        } else if (exe.executionType == 533322) {
          const data = {
            APP_REF_NO: this.inputCaseViewdata?.additionalAttribute3,
          };

          this.http
            .post('/app-event/application-record-update', data)
            .subscribe((data) => {
              console.log('Application record refreshed.');
            });
        } else if (exe.executionType == 533309) {
          //if (tid != undefined && tid != null && tid != '') {
          //
          if (this.parentCommonService)
            this.parentCommonService?.notifyParentCommonServiceSubject?.next({
              data: this.appGenServiceService.getAppGenData(formId, tid),
              fieldId: this.fieldId,
              resultObj: this.commonService?.inputJsonData,
            });

          //
          if (exe?.json?.isMandatory) {
            if (this.appGenFormGroup.valid) {
              this.getDraftData(
                tid,
                exe,
                this.appId,
                afterExecution,
                form,
                formId,
                data,
                rowDataTable,
                transIdColumn,
                addRowDelete,
                res,
                columnData,
                colAr,
                roAr,
                tabFieldId
              );
            } else {
              this.appGenFormGroup.markAllAsTouched();
              this.invalidObj = '';

              this.msgDsplyService.errorToast({
                errors: [
                  {
                    message: this.findInvalidControls(),
                  },
                ],
              });
            }
          } else {
            this.getDraftData(
              tid,
              exe,
              this.appId,
              afterExecution,
              form,
              formId,
              data,
              rowDataTable,
              transIdColumn,
              addRowDelete,
              res,
              columnData,
              colAr,
              roAr,
              tabFieldId
            );
          }
          //}
        } else if (exe.executionType == 533316) {
          let additionalVOList = [...this.commonService.additionalVOList];
          let pagesource: AdditionalVO = {
            key: 'pagesource',
            value: 'previouschecklist',
          };

          additionalVOList.push(pagesource);
          const json = {
            fileId: this.commonService.inputCaseViewdata?.docId,

            // appId:50000,

            appId: this.commonService.inputCaseViewdata?.appId,

            stageId: this.commonService.inputCaseViewdata?.appStageId,

            componentName: 'AppGenMainComponent',

            appFormId: this.commonService.cmnFormId,

            additionalVOList: additionalVOList,
          };

          this.appGenServiceService

            .saveChecklistDetails(json)

            .subscribe((res: any) => {
              this.msgDsplyService.successToast({
                messages: ['Save checklist details.', ''],
              });
            });
        } else if (exe.executionType == 533305) {
          //exe.implementingMethod = 'callRestService()';
          this.callUserdefindFunction(
            exe,
            form,
            data,
            formId,
            tid,
            afterExecution,
            rowDataTable,
            transIdColumn,
            addRowDelete,
            res,
            columnData,
            colAr,
            roAr,
            tabFieldId
          );
          //this.commonService.eventCall(exe.implementingMethod, form, data);
        } else if (exe.executionType == 533307) {
          this.commonService.callNotification(exe.ruleSubNotiId);
        } else if (exe.executionType == 533311) {
          // After Redirect All will Closed
          this.dialog.closeAll();

          this.redirectTo(exe.serviceUrl);
        } else if (exe.executionType == 533326) {
          //  Closed modal event
          this.dialog.closeAll();
        } else if (exe.executionType == 533313) {
          let entityAttributeJson = this.commonService.getEntityAttributeMapData(
            this.commonService.resultObj,
            this.appGenServiceService.getAppGenData(formId, tid)
          );
          for (const key in this.commonService.entityAttributeJson) {
            if (
              Object.prototype.hasOwnProperty.call(entityAttributeJson, key)
            ) {
              let index = key?.indexOf('cke_');
              if (index != null && index == -1) {
                this.dataForPost.caseCorrObj.ruleParams[
                  key
                ] = this.commonService.entityAttributeJson[key];
              }
            }
          }
          Object.keys(entityAttributeJson).forEach((res) => {
            if (entityAttributeJson[res] instanceof Array) {
              entityAttributeJson[res]?.forEach((dataF) => {
                this.plmapColData.forEach((dataPl) => {
                  console.log(dataF, dataPl);
                  if (dataF[dataPl.fieldId]) {
                    dataF[dataPl.fieldId] = JSON.parse(dataF[dataPl.fieldId]);
                    dataF[dataPl.columnId] = JSON.parse(dataF[dataPl.columnId]);
                    dataF = { ...dataF };
                  }
                });
              });
              entityAttributeJson[res] = [...entityAttributeJson[res]];
            }
          });
          const menuFetchDataActionCode = this.menuFetchData?.filter(
            (actionCode) => data.attribute.label == actionCode.PRIV_NAME
          );
          this.dataForPost.caseCorrObj.ruleParams = {
            ...this.dataForPost?.caseCorrObj?.ruleParams,
            ...{ 'QCA.QCAFlag': this.commonService.qcaFlagDatabyApi },
            ...{ 'QCA.QCAPassed': this.commonService.qcaPassFlagDatabyApi },
          };
          this.actionService.customActionCall(
            data.attribute.label,
            [this.inputCaseViewdata],
            [this.inputCaseViewdata],
            this.cases,
            null,
            null,
            null,
            null,
            null,
            menuFetchDataActionCode[0],
            this.dataForPost,
            menuFetchDataActionCode[0].ACTION_CODE
          );
        } else if (exe.executionType == 533314) {
          flag = true;
          let comp;
          let dialogAppgenFormId;
          let appRefIdLocal;

          comp = exe?.className;
          if (exe.className == 'Appgen form') {
            dialogAppgenFormId = exe?.implementingMethod;
            comp = 'AppGenMainComponent';
            //appRefIdLocal = this.commonService.tid;
            if (rowDataTable != undefined) {
              appRefIdLocal = rowDataTable[transIdColumn];
              tid = appRefIdLocal;
            } else {
              appRefIdLocal = this.appGenServiceService.getAppGenData(
                null,
                null
              )[data.fieldId];
            }
          } else {
            dialogAppgenFormId = exe?.implementingMethod;
            comp = exe?.className;
          }
          let additionalVOListForOpenDialog = null;
          if (exe?.json?.additionalAttr) {
            let objAttributeJson = JSON.parse(
              JSON.stringify(exe?.json?.additionalAttr)
            );
            additionalVOListForOpenDialog = this.extractValue(
              objAttributeJson,
              rowDataTable
            );
          }

          let transId;
          let formObjDataTable;
          const dialogRef = this.dialog.open(AppGenDialogComponent, {
            width: '95vw',
            height: '90vh',
            maxWidth: '95vw',
            maxHeight: '90vh',
            data: {
              data: this.inputCaseViewdata,
              parentEventData: this.parentEventData,
              caseVO: this.caseVO,
              cases: this.cases,
              dataForPost: this.dataForPost,
              menuFetchData: this.menuFetchData,
              formId: dialogAppgenFormId,
              appRefId: appRefIdLocal,
              className: comp,
              appGenSource: 'openDialog',
              additionalVOList: additionalVOListForOpenDialog,
              parentCommonService: this.commonService,
            },
            disableClose: true,
          });

          dialogRef.afterClosed().subscribe((event) => {
            flag = false;
            this.skipCurrentExecution(
              this.commonService.appGenFormGroup,
              data,
              formId,
              tid,
              beforeExecution,
              afterExecution,
              exe.executionType
            );

            transId = event?.eventId;
            tid = transId;
            if (event?.isUpdateRowData) {
              formObjDataTable = event?.formData;
              let fieldLabMap = this.createDataTableMap(
                this.commonService.resultObj,
                res.fieldId
              );
              rowDataTable = this.setDataTableObj(
                fieldLabMap,
                formObjDataTable,
                rowDataTable
              );
              rowDataTable = { ...rowDataTable };
            }

            if (rowDataTable != undefined) {
              rowDataTable[transIdColumn] = transId;
              if (plMapColumnId) {
                rowDataTable[plMapColumnId] = JSON.stringify(event?.plmap);
              }
              roAr[res.fieldId][rowDataTable.rowIndex] = {
                ...roAr[res.fieldId][rowDataTable.rowIndex],
                ...rowDataTable,
              };
              if (roAr[res.fieldId]) roAr[res.fieldId] = [...roAr[res.fieldId]];
              let rowData = [...roAr[res.fieldId]];
              if (addRowDelete[res.fieldId]?.length > 0) {
                rowData = [...roAr[res.fieldId], ...addRowDelete[res.fieldId]];
              }
              this.notifyRefreshRows.next({
                rowData: roAr[res?.fieldId],
                fieldId: res?.fieldId,
              });
              rowData?.forEach((rowDataEle, index) => {
                for (const key in rowDataEle) {
                  if (Object.prototype.hasOwnProperty.call(rowDataEle, key)) {
                    let checkIndex = colAr[res.fieldId].findIndex(
                      (x) =>
                        x?.columnId?.toString() == key?.toString() &&
                        x?.type == 0
                    );
                    if (checkIndex != -1) {
                      const element = rowDataEle[key];
                      rowDataEle[key] = this.datePipe.transform(
                        new Date(element),
                        'yyyy-MM-dd'
                      );
                    }
                  }
                }
              });

              if (rowData?.length > 0)
                this.appGenServiceService.setAppGenData(
                  res.fieldId,
                  //this.roAr[fieldId],
                  rowData,
                  colAr[res.fieldId]
                );
              //this.appCommon.updateRows(resCommonCompObj?.fieldId);
              //this.appGenServiceService.setAppGenData(rowData[transIdColumn], transId);
            } else {
              this.appGenServiceService.setAppGenData(data.fieldId, transId);
            }
          });
        } else if (exe.executionType == 533321) {
          console.log('exe', exe);
          let entityAttributeJson = this.commonService.getEntityAttributeMapData(
            this.commonService.resultObj,
            this.appGenServiceService.getAppGenData(formId, tid)
          );
          const body = {
            eventId: exe.json?.eventList,

            eventType: exe.json?.eventType,

            initBy: this.authService?.loggedInUser?.employeeVO?.empId,

            initType: exe.json.initType,

            descPlaceHolderMap: entityAttributeJson,

            appId: this.commonService?.appId,

            logType: exe.json?.logType,

            reqNo: this.inputCaseViewdata?.docId,

            appRefNo: this.inputCaseViewdata?.additionalAttribute3,

            docTypeId: this.inputCaseViewdata?.appTypeId,

            licenceNumber: this.inputCaseViewdata?.additionalAttribute4,

            appRefId: 1, //this.inputCaseViewdata?.additionalAttribute3,

            caseId: this.inputCaseViewdata?.docId,
          };
          this.http
            .post('/events/save-app-gen-audit', body)
            .subscribe((res: any) => {
              console.log('save event logging successfully', res);
            });
        } else if (exe.executionType == 533312) {
          if (this.appGenFormGroup.valid || exe.json.saveAsDraft) {
            let formObj = {
              ...this.appGenServiceService.getAppGenData(this.FORMID, this.tid),
            };
            let formValid = false;
            let dialogMessage = false;
            let labelName;
            this.getKeys(formObj).forEach((index) => {
              let formObjData = formObj[index];
              this.commonService.isDataTableHideShow = this.commonService.isElementHideShow(
                this.commonService.resultObj,
                index
              );
              if (
                this.commonService.componentMap[index] == 12 &&
                this.commonService.isMandatoryComponentMap[index] &&
                !this.commonService.isDataTableHideShow
              ) {
                let count = 0;
                if (formObjData) {
                  let flag = true;
                  this.getKeys(formObjData).forEach((index1) => {
                    if (formObjData[index1].operation == 'delete') {
                      count = count + 1;
                    }

                    let formRowObj = formObjData[index1];
                    if (
                      this.commonService?.isHyperLinkMadatory[index] &&
                      flag &&
                      this.commonService?.isMandatoryComponentMap[
                        this.commonService?.isHyperLinkMadatory[index]
                      ] &&
                      !formRowObj[
                        this.commonService?.isHyperLinkMadatory[index]
                      ]
                    ) {
                      dialogMessage = true;
                      labelName = this.commonService.isLabelName[index];
                      formValid = true;
                      flag = false;
                      this.msgDsplyService.errorToast({
                        errors: [
                          {
                            message:
                              'Please fill dialog data for datatable row ' +
                              labelName,
                          },
                        ],
                      });
                    }
                  });

                  if (formObjData.length == count) {
                    formValid = true;
                    labelName = this.commonService.isLabelName[index];
                  }
                }
                if (!formObjData) {
                  formValid = true;
                  labelName = this.commonService.isLabelName[index];
                }
              }
            });
            if (!formValid) {
              let finalObjectData = this.commonService.FormAudit();
              finalObjectData = {
                ...finalObjectData,
                executionType: exe.executionType,
              };
              // refId: this.refId,
              if (!finalObjectData.hasOwnProperty('transactionId')) {
                Object.keys(finalObjectData).forEach((ele) => {
                  if (!!Number(ele)) {
                    finalObjectData[ele].isAuditable = false;
                    finalObjectData[ele].isModified = false;
                  }
                });
              }
              //For Set Attach Id after Savedata, Attach Id Get From Response
              if (this.resultValueForAttachId) {
                Object.keys(finalObjectData).forEach((key, index) => {
                  if (finalObjectData[key]?.compType == 25) {
                    Object.keys(this.resultValueForAttachId).forEach(
                      (data, index) => {
                        if (data == key) {
                          finalObjectData[key].value = {
                            attachId: this.resultValueForAttachId[data],
                          };
                        }
                      }
                    );
                  }
                });
              }
              this.appGenServiceService.saveData(finalObjectData).subscribe(
                (res1: any) => {
                  console.log('savedata =', res1);
                  this.checkSubmitResponse = res1?.data?.resultValue;
                  this.tid = res1?.data?.resultValue?.transactionId;
                  this.resultValueForAttachId = res1?.data?.resultValue;
                  //this.notifySaveComponentResponse.next(this.checkSubmitResponse);
                  for (const key in this.checkSubmitResponse) {
                    if (
                      Object.prototype.hasOwnProperty.call(
                        this.checkSubmitResponse,
                        key
                      )
                    ) {
                      const element = this.checkSubmitResponse[key];
                      if (!isNaN(Number(key))) {
                        this.notifySaveComponentResponse.next(key);
                      }
                    }
                  }

                  if (!exe.successMessage) {
                    exe.successMessage = 'Form Saved Succesfully';
                  }
                  // Final data for Audit set into CompareData
                  this.commonService.resultValue.isFormFirstTimeLoad = false;
                  this.commonService.compareData2 = JSON.stringify(
                    finalObjectData
                  );

                  this.msgDsplyService.successToast({
                    messages: [exe.successMessage, ''],
                  });
                  this.commonService.setAppGenTransData(
                    res1?.data?.resultValue?.transactionId
                  );
                  let entityAttributeJson = this.commonService.getEntityAttributeMapData(
                    this.commonService.resultObj,
                    this.appGenServiceService.getAppGenData(
                      this.FORMID,
                      this.tid
                    ),
                    false,
                    true
                  );
                  this.commonService.setAppGenTransFormData(
                    entityAttributeJson
                  );

                  //
                  if (this.parentCommonService) {
                    let formObj = {
                      ...this.appGenServiceService.getAppGenData(
                        this.FORMID,
                        this.tid
                      ),
                    };
                    this.getKeys(formObj).forEach((index) => {
                      if (
                        this.commonService.componentMap[index] == 0 &&
                        formObj[index]
                      ) {
                        formObj[index] = this.datePipe.transform(
                          new Date(formObj[index]),
                          'dd/MM/yyyy'
                        );
                      }
                    });
                    this.parentCommonService?.notifyParentCommonServiceSubject?.next(
                      {
                        data: formObj,
                        fieldId: this.fieldId,
                        resultObj: this.commonService?.inputJsonData,
                      }
                    );
                  }
                  //
                  this.executeEventService(
                    afterExecution,
                    this.commonService.appGenFormGroup,
                    data,
                    formId,
                    tid,
                    rowDataTable,
                    transIdColumn,
                    addRowDelete,
                    res,
                    columnData,
                    colAr,
                    roAr,
                    tabFieldId
                  );
                },
                (err: any) => {
                  console.error('Error in saveApi', err);
                  if (!exe.errorMessage) {
                    exe.errorMessage = 'Oops! Something went wrong';
                  }
                  this.msgDsplyService.errorToast({
                    errors: [
                      {
                        message: exe.errorMessage,
                      },
                    ],
                  });
                }
              );
            } else {
              if (!dialogMessage) {
                this.msgDsplyService.errorToast({
                  errors: [
                    {
                      message: 'Please add atleast one row in ' + labelName,
                    },
                  ],
                });
              }
            }
          } else {
            this.appGenFormGroup.markAllAsTouched();

            this.msgDsplyService.errorToast({
              errors: [
                {
                  message: 'Please Enter Mandatory controls',
                },
              ],
            });
          }
        } else if (exe.executionType == 533325) {
          let formObj = {
            ...this.appGenServiceService.getAppGenData(this.FORMID, this.tid),
          };
          let formValid = false;
          let dialogMessage = false;
          let labelName;
          this.getKeys(formObj).forEach((index) => {
            let formObjData = formObj[index];
            if (
              this.commonService.componentMap[index] == 12 &&
              this.commonService.isMandatoryComponentMap[index] &&
              !this.commonService.isDataTableHideShow[index]
            ) {
              let count = 0;
              if (formObjData) {
                let flag = true;
                this.getKeys(formObjData).forEach((index1) => {
                  if (formObjData[index1].operation == 'delete') {
                    count = count + 1;
                  }

                  let formRowObj = formObjData[index1];
                  if (
                    this.commonService?.isHyperLinkMadatory[index] &&
                    flag &&
                    this.commonService?.isMandatoryComponentMap[
                      this.commonService?.isHyperLinkMadatory[index]
                    ] &&
                    !formRowObj[this.commonService?.isHyperLinkMadatory[index]]
                  ) {
                    dialogMessage = true;
                    labelName = this.commonService.isLabelName[index];
                    formValid = true;
                    flag = false;
                    this.msgDsplyService.errorToast({
                      errors: [
                        {
                          message:
                            'Please fill dialog data for datatable row ' +
                            labelName,
                        },
                      ],
                    });
                  }
                });

                if (formObjData.length == count) {
                  formValid = true;
                  labelName = this.commonService.isLabelName[index];
                }
              }
              if (!formObjData) {
                formValid = true;
                labelName = this.commonService.isLabelName[index];
              }
            }
          });
          if (!formValid) {
            let finalObjectData = this.commonService.FormAudit();

            finalObjectData = {
              ...finalObjectData,
              executionType: exe.executionType,
            };
            // refId: this.refId,

            this.appGenServiceService.saveData(finalObjectData).subscribe(
              (res1: any) => {
                console.log('savedata =', res1);
                this.checkSubmitResponse = res1?.data?.resultValue;
                this.tid = res1?.data?.resultValue?.transactionId;
                //this.notifySaveComponentResponse.next(this.checkSubmitResponse);
                for (const key in this.checkSubmitResponse) {
                  if (
                    Object.prototype.hasOwnProperty.call(
                      this.checkSubmitResponse,
                      key
                    )
                  ) {
                    const element = this.checkSubmitResponse[key];
                    if (!isNaN(Number(key))) {
                      this.notifySaveComponentResponse.next(key);
                    }
                  }
                }

                if (!exe.successMessage) {
                  exe.successMessage = 'Form Saved Succesfully';
                }
                // Final data for Audit set into CompareData
                this.commonService.compareData2 = JSON.stringify(
                  finalObjectData
                );

                this.msgDsplyService.successToast({
                  messages: [exe.successMessage, ''],
                });
                this.commonService.setAppGenTransData(
                  res1?.data?.resultValue?.transactionId
                );
                let entityAttributeJson = this.commonService.getEntityAttributeMapData(
                  this.commonService.resultObj,
                  this.appGenServiceService.getAppGenData(
                    this.FORMID,
                    this.tid
                  ),
                  false,
                  true
                );
                this.commonService.setAppGenTransFormData(entityAttributeJson);

                //
                if (this.parentCommonService) {
                  let formObj = {
                    ...this.appGenServiceService.getAppGenData(
                      this.FORMID,
                      this.tid
                    ),
                  };
                  this.getKeys(formObj).forEach((index) => {
                    if (
                      this.commonService.componentMap[index] == 0 &&
                      formObj[index]
                    ) {
                      formObj[index] = this.datePipe.transform(
                        new Date(formObj[index]),
                        'dd/MM/yyyy'
                      );
                    }
                  });
                  this.parentCommonService?.notifyParentCommonServiceSubject?.next(
                    {
                      data: formObj,
                      fieldId: this.fieldId,
                      resultObj: this.commonService?.inputJsonData,
                    }
                  );
                }
                //
                this.executeEventService(
                  afterExecution,
                  this.commonService.appGenFormGroup,
                  data,
                  formId,
                  tid,
                  rowDataTable,
                  transIdColumn,
                  addRowDelete,
                  res,
                  columnData,
                  colAr,
                  roAr,
                  tabFieldId
                );
              },
              (err: any) => {
                console.error('Error in saveApi', err);
                if (!exe.errorMessage) {
                  exe.errorMessage = 'Oops! Something went wrong';
                }
                this.msgDsplyService.errorToast({
                  errors: [
                    {
                      message: exe.errorMessage,
                    },
                  ],
                });
              }
            );
          } else {
            if (!dialogMessage) {
              this.msgDsplyService.errorToast({
                errors: [
                  {
                    message: 'Please add atleast one row in ' + labelName,
                  },
                ],
              });
            }
          }
        } else if (exe.executionType == 533317) {
          //show message
          let messageId = exe.successMessage;
          let dataForPost = {
            LOC_ID: '1',
            ComboId: '533120',
          };
          this.http
            .post('/worklist/get-combo-list', dataForPost)
            .subscribe((res) => {
              const restemp: any = res;
              let alertMessageList = restemp.data;
              let messageString = alertMessageList?.filter(
                (msg) => msg.optionValue == messageId
              );
              this.msgDsplyService.successToast({
                messages: [messageString?.[0]?.optionText],
              });
            });
        } else if (exe.executionType == 533318) {
          //show message string
          let messageString = exe.successMessage;
          this.msgDsplyService.successToast({
            messages: [messageString],
          });
        } else if (exe.executionType == 533319) {
          //show confirmation box
          flag = true;
          let positiveActionLabel = 'Ok';
          let negativeActionLabel = 'No';
          let messageId = exe.successMessage;
          let dataForPost = {
            LOC_ID: '1',
            ComboId: '533120',
          };
          this.http
            .post('/worklist/get-combo-list', dataForPost)
            .subscribe((res) => {
              const restemp: any = res;
              let alertMessageList = restemp.data;
              let messageString = alertMessageList?.filter(
                (msg) => msg.optionValue == messageId
              );
              this.dialogService
                .confirmation(
                  messageString?.[0]?.optionText,
                  positiveActionLabel,
                  negativeActionLabel
                )
                .afterClosed()
                .subscribe((res) => {
                  console.log(res);
                  if (res) {
                    flag = false;
                    this.skipCurrentExecution(
                      this.commonService.appGenFormGroup,
                      data,
                      formId,
                      tid,
                      beforeExecution,
                      afterExecution,
                      exe.executionType
                    );
                  } else {
                    flag = true;
                  }
                });
            });
        } else if (exe.executionType == 533320) {
          //show confirmation box with string
          flag = true;
          let messageString = exe.successMessage;
          let positiveActionLabel = 'Ok';
          let negativeActionLabel = 'No';
          this.dialogService
            .confirmation(
              messageString,
              positiveActionLabel,
              negativeActionLabel
            )
            .afterClosed()
            .subscribe((res) => {
              console.log(res);
              if (res) {
                flag = false;
                this.skipCurrentExecution(
                  this.commonService.appGenFormGroup,
                  data,
                  formId,
                  tid,
                  beforeExecution,
                  afterExecution,
                  exe.executionType
                );
              } else {
                flag = true;
              }
            });
        } else if (exe.executionType == 533323) {
          // FOR QCA CHECK
          let qcaObj = {
            fileId: this.commonService.inputCaseViewdata?.docId,
            childAppId: this.commonService?.appId,
            stageId: this.commonService.inputCaseViewdata?.appStageId,
            levelId: this.commonService.caseVO.subHrhcyLvlPk,
            actionId: data.fieldId,
            empId: this.authService?.loggedInUser?.employeeVO?.empId,
            subId: this.commonService.inputCaseViewdata?.subjectId,
          };
          flag = true;
          this.appGenServiceService.appGenQCACheck(qcaObj).subscribe(
            (res) => {
              console.log('qcaData' + res);
              const { qcaFlag, qcaPassFlag } = res['data'];

              // this.caseVO.ruleParams['QCA.QCAFlag']=qcaFlag
              // this.caseVO.ruleParams['QCA.QCAPassed']=qcaPassFlag

              this.commonService.qcaFlagDatabyApi = qcaFlag;
              this.commonService.qcaPassFlagDatabyApi = qcaPassFlag;

              let qcaList = [qcaFlag, qcaPassFlag];

              let formData = this.commonService.getComponent(
                this.commonService.resultObj,
                ['QCA Flag', 'QCAPassed Flag']
              );

              let filterData = [];
              filterData = this.commonService.resultObj.filter(
                // (item) => item.fieldId == formData[0]
                (item) => formData.includes(item.fieldId)
              );
              filterData.map((element, i) => {
                element.attribute.defaultValue = qcaList[i];
                this.appGenServiceService.setAppGenData(
                  element.attribute.fieldId,
                  qcaList[i]
                );
                this.commonService.appGenFormGroup?.controls[
                  element.attribute.fieldId
                ]?.setValue(qcaList[i]);
              });
              this.skipCurrentExecution(
                this.commonService.appGenFormGroup,
                data,
                formId,
                tid,
                beforeExecution,
                afterExecution,
                exe.executionType
              );
            },
            (err) => {
              console.log(err);
              let formData = this.commonService.getComponent(
                this.commonService.resultObj,
                ['QCA Flag', 'QCAPassed Flag']
              );
              // this.commonService.appGenFormGroup.controls[formData[0]].setValue(true)
              // this.commonService.appGenFormGroup.controls[formData[1]].setValue(true)

              // this.appGenServiceService.setAppGenData(formData[0], true);
              let filterData = [];
              filterData = this.commonService.resultObj.filter(
                // (item) => item.fieldId == formData[0]
                (item) => formData.includes(item.fieldId)
              );
              filterData.forEach((element) => {
                element.attribute.defaultValue = true;
                this.appGenServiceService.setAppGenData(
                  element.attribute.fieldId,
                  true
                );
                this.commonService.appGenFormGroup?.controls[
                  element.attribute.fieldId
                ]?.setValue(true);
              });

              let exeIndex = beforeExecution.findIndex(
                (x) => x.executionType == '533323'
              );
              beforeExecution.splice(exeIndex, 1);
              this.executeBasedOnType(
                this.commonService.appGenFormGroup,
                data,
                formId,
                tid,
                beforeExecution,
                afterExecution
              );
            }
          );
        } else if (exe.executionType == 533324) {
          // FOR ADD AN AUDIT EVENT TYPE
          this.commonService.auditComponentListId =
            exe.json.auditComponentSelectedList;
        } else {
          this.commonService.eventCall(exe.implementingMethod);
        }
      }
    });
  }
  setDataTableObj(fieldLabMap: {}, formObjDataTable: any, rowDataTable: any) {
    this.getKeys(formObjDataTable)?.forEach((index) => {
      let formObjPresent = index;

      if (formObjPresent && formObjDataTable[index]) {
        rowDataTable[formObjPresent] = formObjDataTable[index];
        rowDataTable = { ...rowDataTable };
      }
    });
    return rowDataTable;
  }
  invalidObj: any = '';
  findInvalidControls() {
    this.invalidObj = 'Please fill following mandatory fields \n';
    const controls = this.commonService.appGenFormGroup.controls;
    let count = 1;
    for (const name in controls) {
      if (controls[name].invalid) {
        this.invalidObj =
          this.invalidObj +
          count +
          '. ' +
          this.commonService.isLabelName[name] +
          '  \n';
        count = count + 1;
      }
    }
    return this.invalidObj;
  }
  extractValue(AdditionalAttributeList, rowData) {
    if (AdditionalAttributeList != null) {
      AdditionalAttributeList.forEach((AttributeObject) => {
        for (const key in AttributeObject) {
          if (AttributeObject.hasOwnProperty(key)) {
            if (key == 'value') {
              const element = AttributeObject[key];
              console.log(element);
              if (element.includes('ComponentId')) {
                const parentId = element.split('_')[1];
                if (isNaN(Number(parentId))) {
                  this.commonService.additionalVOList = this.commonService.additionalVOList.filter(
                    (id) => id.key != key
                  );
                  if (rowData != undefined) {
                    AttributeObject[key] = rowData[parentId];
                  } else {
                    let attValue = this.commonService.additionalVOList.filter(
                      (id) => id.key == parentId
                    );

                    AttributeObject[key] = attValue[0]?.value;
                  }
                } else {
                  let fieldType = this.commonService.componentMap[parentId];
                  let objValue = null;
                  if (fieldType == 5) {
                    objValue = this.commonService.appGenFormGroup.controls[
                      parentId
                    ]?.value?.optionValue;
                  } else {
                    objValue = this.commonService.appGenFormGroup.controls[
                      parentId
                    ]?.value;
                  }
                  AttributeObject[key] = objValue;
                }
              }
            }
          }
        }
      });
    }

    return [...this.commonService.additionalVOList, ...AdditionalAttributeList];
  }

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  executeRule(
    data,
    ruleSubNotiId,
    entityAttributeJson,
    form,
    formId?,
    tid?,
    afterExecution?,
    rowDataTable?,
    transIdColumn?,
    addRowDelete?,
    resultObjData?,
    columnData?,
    colAr?,
    roAr?,
    tabFieldId?
  ) {
    let jsonExecution = [
      {
        ruleCode: ruleSubNotiId,
        inputAttributeType: 1,
        ruleType: 2,
        hideErrorMsg: 1,
        inputAttributeMap: entityAttributeJson,
        ruleExecutionType: 2,

        group: false,
      },
    ];
    try {
      this.appGenServiceService.executeRule(jsonExecution).subscribe(
        (res: any) => {
          let ruleObj = res?.data ? res.data[0] : null;

          if (ruleObj) {
            let resultObj = ruleObj?.outputAttributeMap?.ACTION_MAP;

            if (resultObj) {
              let successOrFailure =
                ruleObj?.outputAttributeMap?.CND_RESULT == 'SUCCESS' ? 1 : 0;

              this.createRuleEventObject(
                data,
                resultObj,
                form,
                successOrFailure
              );
            }
            // if (afterExecution && Array.isArray(afterExecution) && afterExecution.length != 0) {
            //   this.executeEventService(afterExecution, form, data, formId, tid, rowDataTable, transIdColumn, addRowDelete,
            //     resultObjData, columnData, colAr, roAr, tabFieldId);
            // }
          }
        },
        (error) => {
          console.log('Rule is not executed', error);
        }
      );
    } catch (e) {
      console.log('catch rule error', e);
    }
    // let resultObj = {
    //   'Employee.studentId': 10,
    //   'Employee.pincode': 2000,
    //   'Employee.city': 'Disable()',
    //   'Employee.total': 'Hide()',
    //    'Employee.total': "LoadCombo('119')",
    //   'Employee.department': 'Show()',
    //   // callGenerateLetter:
    //   //   "callGenerateLetter('504','504','Certificate of Practice')",
    //   callTSFunction: "callTSFunction('callFn()','10')",
    //   //'callNotification':"callNotification('123')"
    // };
    // this.createRuleEventObject(data, resultObj, form);
  }

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  getKeys(map: any) {
    if (map) return Object.keys(map);
  }
  eventObj: any = [];
  createRuleEventObject(data, resultObj, form, successOrFailure?) {
    this.eventObj = [];
    if (resultObj != null) {
      this.getKeys(resultObj)?.forEach((component) => {
        if (
          typeof resultObj[component] != 'number' &&
          (resultObj[component].indexOf('callGenerateLetter') != -1 ||
            resultObj[component].indexOf('callTSFunction') != -1 ||
            resultObj[component].indexOf('callNotification') != -1 ||
            resultObj[component].indexOf('showMessage') != -1)
        ) {
          this.callCustomFuntion(
            data,
            component,
            resultObj[component],
            successOrFailure
          );
        } else {
          let componentObj = component.split('.');

          this.getAttributeById(
            data,
            this.commonService.resultObj,
            componentObj[0],
            componentObj[1],
            resultObj[component],
            null,
            successOrFailure
          );
        }
      });
    }
    if (this.eventObj != null) {
      this.getKeys(this.eventObj).forEach((index) => {
        this.callVisibilityRule(
          this.eventObj[index],
          this.appGenFormGroup,
          this.commonService.tid,
          true
        );
      });
    }
  }
  callCustomFuntion(data, entityName, objValue, successOrFailure?) {
    let event1 = null;
    if (
      typeof objValue != 'number' &&
      entityName.indexOf('callGenerateLetter') != -1
    ) {
      let matches = objValue.match(/'(.*?)'/g);

      event1 = this.commonService.createEventObj(
        data?.fieldId,
        null,
        'Generate Letter with Edit',
        matches,
        data.fieldType,
        successOrFailure
      );
    } else if (
      typeof objValue != 'number' &&
      entityName.indexOf('callTSFunction') != -1
    ) {
      let matches = objValue.match(/'(.*?)'/g);

      event1 = this.commonService.createEventObj(
        data?.fieldId,
        null,
        'Call TS Funtion',
        matches,
        data.fieldType,
        successOrFailure
      );
    } else if (
      typeof objValue != 'number' &&
      entityName.indexOf('callNotification') != -1
    ) {
      let matches = objValue.match(/'(.*?)'/g);

      event1 = this.commonService.createEventObj(
        data?.fieldId,
        null,
        'Notification',
        matches,
        data.fieldType,
        successOrFailure
      );
    } else if (
      typeof objValue != 'number' &&
      entityName.indexOf('showMessage') != -1
    ) {
      let matches = objValue.match(/'(.*?)'/g);

      event1 = this.commonService.createEventObj(
        data?.fieldId,
        null,
        'ShowMessage',
        matches,
        data.fieldType,
        successOrFailure
      );
    }
    this.eventObj.push(event1);
  }
  getAttributeById(
    data,
    jsonObject,
    entityName,
    attributeName,
    objValue,
    templateMap,
    successOrFailure?
  ) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (
          jsonObject[component]?.parentEntityName == entityName &&
          (jsonObject[component]?.attributeName == attributeName ||
            (jsonObject[component]?.attribute.fieldType == 90 &&
              jsonObject[component]?.attributeName == 'cke_' + attributeName))
        ) {
          let event1 = null;
          if (objValue == 'hide()') {
            event1 = this.commonService.createEventObj(
              data?.fieldId,
              jsonObject[component]?.fieldId,
              'Hide',
              null,
              jsonObject[component].fieldType,
              successOrFailure
            );
          } else if (objValue == 'show()') {
            event1 = this.commonService.createEventObj(
              data?.fieldId,
              jsonObject[component]?.fieldId,
              'Show',
              null,
              jsonObject[component].fieldType,
              successOrFailure
            );
          } else if (objValue == 'setfocus()') {
            event1 = this.commonService.createEventObj(
              data?.fieldId,
              jsonObject[component]?.fieldId,
              'SetFocus',
              null,
              jsonObject[component].fieldType,
              successOrFailure
            );
          } else if (objValue === 'enable()') {
            event1 = this.commonService.createEventObj(
              data?.fieldId,
              jsonObject[component]?.fieldId,
              'Enabled',
              null,
              jsonObject[component].fieldType,
              successOrFailure
            );
          } else if (objValue === 'disable()') {
            event1 = this.commonService.createEventObj(
              data?.fieldId,
              jsonObject[component]?.fieldId,
              'Disabled',
              null,
              jsonObject[component].fieldType,
              successOrFailure
            );
          } else if (objValue === 'mandatory()') {
            event1 = this.commonService.createEventObj(
              data?.fieldId,
              jsonObject[component]?.fieldId,
              'Mandatory',
              null,
              jsonObject[component].fieldType,
              successOrFailure
            );
          } else if (objValue === 'optional()') {
            event1 = this.commonService.createEventObj(
              data?.fieldId,
              jsonObject[component]?.fieldId,
              'Optional',
              null,
              jsonObject[component].fieldType,
              successOrFailure
            );
          } else if (
            (jsonObject[component]?.fieldType == 5 ||
              jsonObject[component]?.fieldType == 81 ||
              jsonObject[component]?.fieldType == 71 ||
              jsonObject[component]?.fieldType == 98) &&
            objValue.indexOf('LoadCombo') != -1
          ) {
            objValue = objValue.match(/'(.*?)'/g);

            event1 = this.commonService.createEventObj(
              data.fieldId,
              jsonObject[component]?.fieldId,
              'Load Combo',
              objValue,
              jsonObject[component].fieldType,
              successOrFailure
            );
          } else if (
            (jsonObject[component]?.fieldType == 3 ||
              jsonObject[component]?.fieldType == 1 ||
              jsonObject[component]?.fieldType == 10 ||
              jsonObject[component]?.fieldType == 44 ||
              jsonObject[component]?.fieldType == 5 ||
              jsonObject[component]?.fieldType == 81 ||
              jsonObject[component]?.fieldType == 71 ||
              jsonObject[component]?.fieldType == 98) &&
            (typeof objValue === 'number' || typeof objValue === 'string')
          ) {
            event1 = this.commonService.createEventObj(
              data.fieldId,
              jsonObject[component]?.fieldId,
              'SetValue',
              objValue,
              jsonObject[component].fieldType,
              successOrFailure
            );
          }
          this.eventObj.push(event1);
          return jsonObject[component];
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.getAttributeById(
          data,
          jsonObject[component]?.children,
          entityName,
          attributeName,
          objValue,
          templateMap,
          successOrFailure
        );
      }
    });
    return jsonObject;
  }

  getDraftData(
    tid,
    exe,
    appId,
    afterExecution,
    form,
    formId,
    data?,
    rowDataTable?,
    transIdColumn?,
    addRowDelete?,
    result?,
    columnData?,
    colAr?,
    roAr?,
    tabFieldId?
  ) {
    let finalObjectData = this.commonService.FormAudit(1);
    finalObjectData = {
      ...finalObjectData,
      executionType: exe.executionType,
    };
    // refId: this.refId,

    this.appGenServiceService
      .saveData(finalObjectData)
      .subscribe((res: any) => {
        console.log('savedata =', res);
        //
        console.log('savedata =', res);
        this.checkSubmitResponse = res?.data?.resultValue;
        //this.notifySaveComponentResponse.next(this.checkSubmitResponse);
        for (const key in this.checkSubmitResponse) {
          if (
            Object.prototype.hasOwnProperty.call(this.checkSubmitResponse, key)
          ) {
            const element = this.checkSubmitResponse[key];
            if (!isNaN(Number(key))) {
              this.notifySaveComponentResponse.next(key);
            }
          }
        }

        if (!exe.successMessage) {
          exe.successMessage = 'Form Saved Succesfully';
        }

        // Final data for Audit set into CompareData
        this.commonService.compareData2 = JSON.stringify(finalObjectData);

        this.msgDsplyService.successToast({
          messages: [exe.successMessage, ''],
        });
        this.commonService.setAppGenTransData(
          res?.data?.resultValue?.transactionId
        );
        let entityAttributeJson = this.commonService.getEntityAttributeMapData(
          this.commonService.resultObj,
          this.appGenServiceService.getAppGenData(this.FORMID, this.tid),
          false,
          true
        );
        this.commonService.setAppGenTransFormData(entityAttributeJson);

        //
        if (this.parentCommonService) {
          let formObj = {
            ...this.appGenServiceService.getAppGenData(this.FORMID, this.tid),
          };
          this.getKeys(formObj).forEach((index) => {
            if (this.commonService.componentMap[index] == 0 && formObj[index]) {
              formObj[index] = this.datePipe.transform(
                new Date(formObj[index]),
                'dd/MM/yyyy'
              );
            }
          });
          this.parentCommonService?.notifyParentCommonServiceSubject?.next({
            data: formObj,
            fieldId: this.fieldId,
            resultObj: this.commonService?.inputJsonData,
          });
        }
        if (this.parentCommonService)
          this.parentCommonService?.notifyParentCommonServiceSubject?.next({
            data: this.appGenServiceService.getAppGenData(
              formId,
              res?.data?.resultValue?.transactionId
            ),
            fieldId: this.fieldId,
            resultObj: this.commonService?.inputJsonData,
          });
        //
        if (res.data?.resultValue?.transactionId) {
          this.commonService.tid = res.data?.resultValue?.transactionId;

          this.callGenerateDraft(
            exe,
            res.data.resultValue.transactionId,
            appId,
            afterExecution,
            form,
            formId,
            data,
            tabFieldId,
            rowDataTable,
            transIdColumn,
            addRowDelete,
            result,
            columnData,
            colAr,
            roAr
          );
        } else {
          this.msgDsplyService.errorToast({
            errors: [
              {
                message: 'your trangaction id is not generated',
              },
            ],
          });
        }
      });
  }

  prepareAdditionalDtls(): any {
    return {
      subjectId: this.inputCaseViewdata?.subjectId,

      licenceNumber: this.inputCaseViewdata?.additionalAttribute4,

      custRefNum: this.inputCaseViewdata?.additionalAttribute2,

      applicationRefId: this.inputCaseViewdata?.additionalAttribute3,

      qcaPassed: this.inputCaseViewdata?.qcaPassed,
      qcaFlag: this.inputCaseViewdata?.qcaFlag,
      fileStageId: this.inputCaseViewdata?.fileStageId,
      statusId: this.inputCaseViewdata?.statusId,
      applicationStatusName: this.inputCaseViewdata?.applicationStatusName,
      fileId: this.inputCaseViewdata?.fileId,

      jobId: '-1',

      reqType: this.inputCaseViewdata?.additionalAttribute4,

      reqTrnId: this.inputCaseViewdata?.additionalAttribute4,

      badgeNumber: '123',

      brailleFlag: 'Yes',

      deliveryClass: 'deliveryClass',

      reqNo: this.inputCaseViewdata?.docNo,

      appRefNo: this.inputCaseViewdata?.additionalAttribute3,

      docTypeId: this.inputCaseViewdata?.appTypeId,

      data: this.inputCaseViewdata,

      parentEventData: this.parentEventData,

      caseVO: this.caseVO,

      cases: this.cases,

      menuFetchData: this.menuFetchData,

      appId: 1,
    };
  }

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  callGenerateDraft(
    data,
    trangactionId,
    appId,
    afterExecution,
    form,
    formId,

    data1?,
    tabIndex?,
    rowDataTable?,
    transIdColumn?,
    addRowDelete?,
    result?,
    columnData?,
    colAr?,
    roAr?
  ) {
    let optionVal =
      data.ruleSubNotiId != undefined
        ? data.ruleSubNotiId
        : data.notificationTmpltId;
    let placeHolderMap = {};
    let devFormData = JSON.parse(localStorage.getItem('developerFormData'));
    let entityAttributeJson = this.commonService.getEntityAttributeMapData(
      this.commonService.resultObj,
      this.appGenServiceService.getAppGenData(this.cmnFormId, this.tid),
      true,
      true,
      devFormData, // this.developerFormData,
      false,
      true,
      'dd MMMM yyyy'
    );

    let addtionalAttribute = this.commonService.additionalVOList;
    let currentDate = new Date();

    placeHolderMap = {
      ...entityAttributeJson,
      ...addtionalAttribute,
      // ...{ currentDate: currentDate },
    };
    const dialogRef1 = this.dialog?.open(DraftDialogComponent, {
      width: '97vw',
      height: '97vh',
      maxWidth: '97vw',
      maxHeight: '97vh',
      data: {
        selectedDraft: { draftId: data?.draftId },
        refId: this.inputCaseViewdata?.docId,
        templateId: { optionValue: data?.draftId },
        appId: this.inputCaseViewdata?.appTypeId,
        draftId: data?.draftId,
        appTypeId: this.inputCaseViewdata?.appTypeId,

        docTypeCode: data?.json?.docTypeCode,

        title: data?.tmpltName ? data?.tmpltName : 'Letter',

        case: this.inputCaseViewdata,

        actionId: -1, //need to check

        templateNotificationEventId: data?.json?.letterEventId, //need to check

        additionalDtls: this.prepareAdditionalDtls(),

        paramForLetter: entityAttributeJson,
        plMapForLetter: placeHolderMap,
      },

      disableClose: true,
    });
    dialogRef1.afterClosed().subscribe((result) => {
      // this.initializeFormGroup(this.resultObj);
      if (result?.canProceed) {
        this.executeEventService(
          afterExecution,
          form,
          data1,
          formId,
          trangactionId,
          rowDataTable,
          transIdColumn,
          addRowDelete,
          result,
          columnData,
          colAr,
          roAr,
          tabIndex
        );
      }
    });
  }
  initializeCombo(jsonObject) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.attribute?.comboMap) {
          this.createCombo(jsonObject[component]);
          // if there is visibility rule or not
          // loop
          // to find out dependent field id's
          // fieldid <-> 9876 comboMap
        }
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.initializeCombo(jsonObject[component]?.children);
      }
    });
    return jsonObject;
  }

  createCombo(data) {
    if (data?.attribute?.comboMap) {
      if (
        data?.attribute?.comboConfigurationString != null &&
        data?.attribute?.comboConfigurationString != '' &&
        data?.attribute?.comboConfigurationString &&
        data?.attribute?.comboConfigurationString != '{}' &&
        data?.attribute?.comboConfigurationString != '""'
      ) {
        this.comboConfig(data);
      } else {
        this.callCombo(data);
      }
    }
  }
  comboConfig(data?) {
    let comboString = data?.attribute?.comboConfigurationString;
    if (
      comboString &&
      JSON.stringify(comboString) != '{}' &&
      comboString != '""'
    ) {
      let tempComboConfigurationString = Object.assign({}, comboString);
      let flag = false;
      let comboStringVal = {};
      for (let key in tempComboConfigurationString) {
        let tempString: string = tempComboConfigurationString[key];
        tempString = Number(tempString) ? tempString.toString() : tempString;
        if (tempString.includes('ComponentId')) {
          let parentId = tempComboConfigurationString[key].split('_')[1];
          let fieldType = this.commonService.componentMap[parentId];
          let objValue = null;
          if (fieldType == 5) {
            objValue = this.commonService.appGenFormGroup.controls[parentId]
              ?.value?.optionValue;
          } else {
            objValue = this.commonService.appGenFormGroup.controls[parentId]
              ?.value;
          }
          comboStringVal[key] = objValue;
          flag = true;
        } else {
          comboStringVal[key] = tempString;
        }
      }

      if (comboStringVal && JSON.stringify(comboStringVal) != '{}') {
        this.callCombo(data, comboStringVal);
      }
    } else {
      this.callCombo(data);
    }
  }
  callCombo(data?, comboConfigurationString?) {
    if (data?.fieldType != 19) {
      if (
        comboConfigurationString &&
        Object.keys(comboConfigurationString).length > 0
      ) {
        let flag = true;
        Object.keys(comboConfigurationString).forEach((key) => {
          if (comboConfigurationString[key]) {
            typeof Number(comboConfigurationString[key]) == 'number'
              ? (comboConfigurationString[key] = Number(
                  comboConfigurationString[key]
                ))
              : comboConfigurationString[key];
          } else {
            flag = false;
          }
        });
        if (flag) {
          let subject = new BehaviorSubject(null);
          this.commonService.comboMapValues[
            data?.attribute?.comboMap
          ] = subject.asObservable();
          let subcribe = this.appGenServiceService.setDropDown(
            data?.attribute?.comboMap,
            comboConfigurationString
          );
          this.createSubscribeMethood(subcribe, data, subject);
        }
      } else {
        this.comboLoadMethod(data);
      }
      // if (this.commonService.comboMapValues[data?.attribute?.comboMap]) {
      //   let subcribe = this.commonService.comboMapValues[
      //     data?.attribute?.comboMap
      //   ];
      //   //this.comboLoadMethod(data);
      //   this.createSubscribeMethood(subcribe, data);
      // } else {
      //   let subject = new BehaviorSubject(null);
      //   this.commonService.comboMapValues[
      //     data?.attribute?.comboMap
      //   ] = subject.asObservable();
      //   let subcribe = this.appGenServiceService.setDropDown(
      //     data?.attribute?.comboMap,
      //     comboConfigurationString
      //   );
      //   this.createSubscribeMethood(subcribe, data, subject);
      // }
    }
  }
  createSubscribeMethood(subcribe, data, subject?) {
    subcribe
      .pipe(
        filter((newData) => !!newData),
        take(1)
      )
      .subscribe(
        (res: any) => {
          data.attribute.comboMapValues = res.data;
          this.comboLoadMethod(data);
          if (subject) {
            subject.next(res);
          }
        },
        (err) => {
          console.error('error in combo', err);
        }
      );
  }
  comboLoadMethod(data) {
    if (data?.attribute?.comboMapValues) {
      if (data.attribute?.defaultValue && !data?.defaultValue) {
        let defaultVal = null;
        if (this.commonService.eventId != 23) {
          defaultVal = data.attribute?.defaultValue;
          data.attribute.defaultValue = data.attribute.comboMapValues.find(
            (o) => o.optionValue === defaultVal
          );
          defaultVal = data.attribute.defaultValue;
        } else {
          defaultVal = data.defaultValue
            ? data.defaultValue
            : data.tempDefaultValue;
          data.defaultValue = data.attribute.comboMapValues.find(
            (o) => o.optionValue === defaultVal
          );
          defaultVal = data.defaultValue;
        }

        this.appGenServiceService.setAppGenData(data.fieldId, defaultVal);
        if (this.parentCommonService) {
          let formObj = {
            ...this.appGenServiceService.getAppGenData(this.FORMID, this.tid),
          };
          this.getKeys(formObj).forEach((index) => {
            if (this.commonService.componentMap[index] == 0 && formObj[index]) {
              formObj[index] = this.datePipe.transform(
                new Date(formObj[index]),
                'dd/MM/yyyy'
              );
            }
          });
          this.parentCommonService?.notifyParentCommonServiceSubject?.next({
            data: formObj,
            fieldId: this.fieldId,
            resultObj: this.commonService?.inputJsonData,
          });
        }
      } else {
        let defaultVal = null;
        if (this.commonService.eventId == 23) {
          defaultVal = data.defaultValue
            ? data.defaultValue
            : data.tempDefaultValue;
          let value = data.attribute.comboMapValues.filter(
            (res) => res.optionValue == defaultVal
          );
          data.defaultValue = value[0];
          defaultVal = data.defaultValue;
        } else {
          defaultVal = data?.attribute?.defaultValue
            ? data?.attribute?.defaultValue
            : data.tempDefaultValue;
          let value = data.attribute.comboMapValues.filter(
            (res) => res.optionValue == defaultVal
          );
          data.attribute.defaultValue = value[0];
          defaultVal = data.attribute.defaultValue;
        }

        // this.appGenServiceService.setAppGenData(data.fieldId, defaultVal);
        this.commonService.setAppGenDataForAudit(data.fieldId, defaultVal);
        if (this.parentCommonService) {
          let formObj = {
            ...this.appGenServiceService.getAppGenData(this.FORMID, this.tid),
          };
          this.getKeys(formObj).forEach((index) => {
            if (this.commonService.componentMap[index] == 0 && formObj[index]) {
              formObj[index] = this.datePipe.transform(
                new Date(formObj[index]),
                'dd/MM/yyyy'
              );
            }
          });
          this.parentCommonService?.notifyParentCommonServiceSubject?.next({
            data: formObj,
            fieldId: this.fieldId,
            resultObj: this.commonService?.inputJsonData,
          });
        }
      }
      if (data?.attribute?.doRunAdvRule) {
        this.callAdvanceRule(data);
      }
    }
  }

  initializeVisibilityRule(jsonObject) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (
          jsonObject[component].fieldType != 99 &&
          jsonObject[component].fieldType != 102
        ) {
          this.callVisibilityRule(
            jsonObject[component],
            this.commonService.appGenFormGroup,
            this.tid
          );
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.initializeVisibilityRule(jsonObject[component]?.children);
      }
    });
    return jsonObject;
  }

  // hidden components initalize visiblity rule
  initializeVisibilityRuleForHiddenComponent(jsonObject) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.attribute?.hiddenComponent) {
          this.callVisibilityRule(
            jsonObject[component],
            this.commonService.appGenFormGroup,
            this.tid
          );
          //----------------------------------------------//
          //----------------------------------------------//
          //----------------------------------------------//

          // For type work Hidden Components Initalize
          if (
            jsonObject[component]?.attribute?.comboConfigurationString &&
            JSON.stringify(
              jsonObject[component]?.attribute?.comboConfigurationString
            ) != '{}'
          ) {
            this.commonService.findcomboStringObj(
              this.commonService.resultObj,
              jsonObject[component]
            );
          }

          //----------------------------------------------//
          //----------------------------------------------//
          //----------------------------------------------//
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.initializeVisibilityRuleForHiddenComponent(
          jsonObject[component]?.children
        );
      }
    });
    return jsonObject;
  }
  initializeVisibilityRuleForTabComponent(jsonObject) {
    this.getKeys(jsonObject)?.forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component].fieldType == 0) {
          jsonObject[component]?.attribute?.validations?.forEach((comp) => {
            this.commonService.dateValidation(
              comp.validationId,
              comp.otherCmpFormId,
              comp.cmpFormId,

              jsonObject[component],
              true,
              true
            );
          });
        }

        if (
          jsonObject[component]?.fieldType == 102 &&
          Array.isArray(jsonObject[component]?.cmnFormFieldEventList)
        ) {
          let tabChildren = jsonObject[component]?.children;
          let flag = true;
          this.getKeys(tabChildren)?.forEach((index) => {
            if (!tabChildren[index]?.attribute?.hideShow && flag) {
              this.callVisibilityRule(
                jsonObject[component],
                this.commonService.appGenFormGroup,
                this.commonService.tid,
                null,
                tabChildren[index]?.fieldId
              );
              flag = false;
            }
          });
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.initializeVisibilityRuleForTabComponent(
          jsonObject[component]?.children
        );
      }
    });
    return jsonObject;
  }
  initializeAdvanceVisibilityRule(jsonObject) {
    this.getKeys(jsonObject).forEach((component) => {
      if (
        !Array.isArray(jsonObject[component]) &&
        !jsonObject[component]?.doRunAdvRule
      ) {
        this.callAdvanceRule(jsonObject[component]);
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.initializeAdvanceVisibilityRule(jsonObject[component]?.children);
      }
    });
    return jsonObject;
  }
  createDataTableMap(jsonObject, tableId) {
    let tableMap = {};
    this.createDataTableFieldIdMap(jsonObject, tableId, tableMap);
    return tableMap;
  }

  createDataTableFieldIdMap(jsonObject, tableId, tableMap) {
    this.getKeys(jsonObject)?.forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component].fieldId == tableId) {
          let children = jsonObject[component].children;
          this.getKeys(children)?.forEach((index) => {
            if (children[index]?.children[0]) {
              tableMap[children[index]?.children[0]?.lbl] =
                children[index]?.children[0]?.fieldId;
            }
          });
          return tableMap;
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.createDataTableFieldIdMap(
          jsonObject[component]?.children,
          tableId,
          tableMap
        );
      }
    });
    return tableMap;
  }

  //skip current Execution

  skipCurrentExecution(
    formGroup,
    data,
    formId,
    tid,
    beforeExecution,
    afterExecution,
    excutionTypeValue
  ) {
    let exeIndex = beforeExecution.findIndex(
      (x) => x.executionType == excutionTypeValue
    );

    beforeExecution.splice(0, exeIndex + 1);
    this.executeBasedOnType(
      formGroup,
      data,
      formId,
      tid,
      beforeExecution,
      afterExecution
    );
  }
}
